export default __webpack_public_path__ + "static/media/lifeofset.8ea37179.png";